<template>
	<div>
		<AgencyBanner />
		<div class="content-zsy">
			<div v-if="show">
				<div class="config-title-wrap">
					<div class="left">
						<h3>상품 정보 입력</h3>
						<p>
							<strong>구매대행 상품 정보 입력</strong><br>
							구매를 의뢰할 상품의 관련정보를 정확하게 입력해 주세요.<br>
							<!-- 상품의 이미지를 등록해 주시면 보다 정확한 상세검수진행이 가능합니다.<br> -->
							<span class="color-red">구매대행 상품과 신청서 , 배송대행 상품과 신청서는 합배송이 불가합니다.</span>
						</p>
					</div>
					<div class="get-order">
						<div class="top">
							<ul>
								<li>1688<img src="../../assets/icon/shipping-auto-img1.png" alt="1688" loading="lazy"></li>
								<li>타오바오<img src="../../assets/icon/shipping-auto-img2.png" alt="타오바오" loading="lazy"></li>
							</ul>
							<a @click="centerDialogVisible = true" class="event-common-click-dialog">구매목록<br>가져오기</a>
						</div>
						<!-- <a href="/xlsUpload" target="_blank" class="link-excel">
							<img src="../../assets/icon/shipping-excel.png" alt="엑셀대량등록" loading="lazy">엑셀대량등록
						</a> -->
					</div>
					
				</div>
				
				<!-- 배송방법 및 통관방법 정보 표시 显示配送方式及通关方式信息-->
				<div style="background-color: #f5f7fa; border: 1px solid #ebeef5; padding: 15px 20px; border-radius: 10px; margin-bottom: 20px; display: flex; gap: 40px; font-size: 15px;">
					<div>
						<strong style="color: #606266;">배송방법 (배송지):</strong>
						<span style="margin-left: 10px; font-weight: bold; color: #303133;">
							{{ deliveryCenterCode === 'CN_AIR' ? '항공' : (deliveryCenterCode === 'CN_SHIP' ? '해상' : (deliveryCenterCode === 'CN_LCL' ? '화물' : deliveryCenterCode)) }}
						</span>
					</div>
					<div>
						<strong style="color: #606266;">통관방법:</strong>
						<span style="margin-left: 10px; font-weight: bold; color: #303133;">
							{{ customsTypeName || '-' }}
						</span>
					</div>
				</div>

				<div style="position: -webkit-sticky; position: sticky; top: 120px; z-index: 999; display: flex; justify-content: flex-end; margin-bottom: 20px; background-color: #fff; padding: 10px 0;">
					<el-button
						type="primary" 
						icon="el-icon-plus" 
						@click="addItem"
					>
						상품추가
					</el-button>
				</div>
				
				
				<el-form
				  ref="dynamicForm" 
				  :model="formData" 
				  :label-width="isMobile?'110px':'130px'"
				>
					<!-- 动态表单项列表 -->
					<div 
						v-for="(item, index) in formData.items" 
						:key="item.id" 
					>
					<!-- 表单项标题 -->
					<!--<el-divider :content="`表单项 ${index + 1}`"></el-divider> -->
					<div style="padding:10px 0 20px 30px;">
						<el-button
							type="primary" plain		disabled		
						>
							{{index+1}}
						</el-button>
						<!-- 删除按钮 -->
					  <el-button 
						type="danger" 
						icon="el-icon-delete" 
						@click="removeItem(index)"
						:disabled="formData.items.length <= 1"
					  >
						삭제
					  </el-button>
					</div>

					<el-row>
						<el-col :xs="24" :sm="8">
							<el-form-item >
								<div class="flex" style="align-items:center;">
									<el-button type="primary" @click="onUpload(index)" size="small">이미지 등록</el-button>
									<a target="_blank" :href="formatImgUrl(item.imageUrl)" v-if="item.imageUrl">
										<el-image 
											style="width:140px;height:140px;border-radius: 10px; margin-left: 10px;"
											:src="formatImgUrl(item.imageUrl)" referrerpolicy="no-referrer"
											fit="cover"></el-image>
									</a>
									<div v-else style="width:140px;height:140px;border-radius: 10px; margin-left: 10px; background-color: #f5f7fa; border: 1px solid #ebeef5; display: flex; align-items: center; justify-content: center;">
										<i class="el-icon-picture-outline" style="font-size: 30px; color: #909399;"></i>
									</div>
								</div>
							</el-form-item>
						</el-col>
						<el-col :xs="24" :sm="8">
							<el-form-item
							  :label="'품목분류'"
							  :prop="`items.${index}.category_name`"
							  :rules="[
								{ required: true, message: '품목분류 필수', trigger: 'change' },
							  ]"
							>
								<div class="flex">
									<el-popover
										placement="bottom"
										width="700"
										trigger="click"
										v-model="item.showPopover"
										@show="onCategoryDialog(index)"
										popper-class="category-popper"
										style="flex: 1;"
									>
										<div class="category-dropdown-content">
											<div class="scroller-container">
												<div class="v-table-header">
													<div class="v-col-l1">1차 분류</div>
													<div class="v-col-l2">2차 분류 (HS Code)</div>
													<div class="v-col-l3">3차 분류 (상세)</div>
												</div>
												
												<RecycleScroller
													class="category-v-scroller"
													:items="item.showPopover ? filteredCategories : []"
													:item-size="65"
													key-field="uniqueId"
													v-slot="{ item: catItem }"
												>
													<div class="v-category-row" @click="handleSelectCategory(catItem)" style="cursor: pointer;">
														<div class="v-col-l1">
															<div class="ko" v-html="highlightCategoryText(catItem.l1)"></div>
														</div>
														<div class="v-col-l2">
															<div class="ko">
																<span v-html="highlightCategoryText(catItem.l2)"></span>
																<span class="code">({{' '}}<span v-html="highlightCategoryText(catItem.l2_code)"></span>{{' '}})</span>
															</div>
															<div class="cn" v-if="catItem.l2_cn" v-html="highlightCategoryText(catItem.l2_cn)"></div>
														</div>
														<div class="v-col-l3">
															<div class="ko" v-html="highlightCategoryText(catItem.l3)"></div>
															<div class="code" v-if="catItem.l3_code !== '-'" v-html="highlightCategoryText(catItem.l3_code)"></div>
														</div>
													</div>
												</RecycleScroller>
											</div>
										</div>
										<el-input 
											slot="reference" 
											v-model="item.category_name" 
											placeholder="분류를 입력하거나 선택하세요" 
											@input="onSearchInput(index)"
										></el-input>
									</el-popover>
									<el-popover
										placement="top"
										width="300"
										trigger="hover"
										>
										<div>
											원하시는 품목분류가 없으신가요?<br>추가희망 하시는 품목분류를 고객센터로<br>알려주시면 즉시 추가하여드립니다
										</div>
										<i class="el-icon-question icon-question"  slot="reference"></i>
									</el-popover>
								</div>
								
							</el-form-item>
						</el-col>
						<el-col :xs="24" :sm="8">
							<!-- 商品名称（英文） -->
							<el-form-item 
							  :label="'상품명(영문)'"
							  :prop="`items.${index}.goods_name`"
							  :rules="[
								{ required: true, message: '상품명 필수', trigger: 'blur' },
								//{ min: 2, max: 10, message: '姓名长度在 2-10 个字符之间', trigger: 'blur' }
							  ]"
							>
								<div class="flex">
									<el-input v-model="item.goods_name"  clearable ></el-input>
									<el-popover placement="top" width="300" trigger="hover" >
										<div>
											검색( HS코드네비게이션)에서 보다 정확한 결과를 얻을수 있습니다
										</div>
										<i class="el-icon-question icon-question"  slot="reference"></i>
									</el-popover>
								</div>
	  
							</el-form-item>
						</el-col>
			<!-- 			<el-col :xs="24" :sm="8">
		
							<el-form-item 
							  :label="'트래킹넘버'"
							  :prop="`items.${index}.tracking_no`"
							>
								<div class="flex">
									<el-input v-model="item.tracking_no" placeholder="여러개 입력시 ,(콤마)" clearable ></el-input>
									<el-popover placement="top" width="300" trigger="hover" >
										<div>
											판매자 상품발송후 제공된 트래킹번호를 즉시 입력해주세요<br>입력이 안될경우 노데이터로 분류되어서 입고가 지연됩니다.
										</div>
										<i class="el-icon-question icon-question"  slot="reference"></i>
									</el-popover>
								</div>
							  
							</el-form-item>
						</el-col> -->
						<el-col :xs="24" :sm="8">
							<!-- 尺寸（中文）size -->
							<el-form-item 
							  :label="'사이즈(중국어)'"
							  :prop="`items.${index}.size`"
							>
								<div class="flex">
									<el-input v-model="item.size"  clearable ></el-input>
								</div>
							</el-form-item>
						</el-col>
		<!-- 				<el-col :xs="24" :sm="8">
						
							<el-form-item 
							  :label="'주문번호'"
							  :prop="`items.${index}.order_no`"
							>
								<div class="flex">
									<el-input v-model="item.order_no"  clearable ></el-input>
									<el-popover placement="top" width="300" trigger="hover" >
										<div>
											구매 주문번호를 입력해주세요.
										</div>
										<i class="el-icon-question icon-question"  slot="reference"></i>
									</el-popover>
								</div>
							</el-form-item>
						</el-col> -->
						<el-col :xs="24" :sm="8">
							<!-- 颜色（中文） -->
							<el-form-item 
							  :label="'색상(중국어)'"
							  :prop="`items.${index}.color`"
							>
								<div class="flex">
									<el-input v-model="item.color"  clearable ></el-input>
								</div>
							</el-form-item>
						</el-col>
						<el-col :xs="24" :sm="8">
							<!-- 单价 -->
							<el-form-item 
							  :label="'단가'"
							  :prop="`items.${index}.price`"
							  :rules="[
								{ required: true, message: '단가 필수', trigger: 'blur' },
							  ]"
							>
								<div class="flex">
									<el-input v-model="item.price" clearable @input="item.price = item.price.match(/^\d*(\.?\d{0,2})/g)[0] || ''"></el-input>
									<div style="padding-left: 5px;" >CNY</div>
								</div> 
							</el-form-item>
						</el-col>
						<el-col :xs="24" :sm="8">
							<!-- 管理编号 -->
							<el-form-item 
							  :label="'관리코드'"
							  :prop="`items.${index}.product_code`"
							>
								<div class="flex">
									<el-input v-model="item.product_code"  clearable ></el-input>
									<el-popover placement="top" width="300" trigger="hover" >
										<div>
											관리코드를 부여해서 관리해보세요
										</div>
										<i class="el-icon-question icon-question"  slot="reference"></i>
									</el-popover>
								</div>
							</el-form-item>
						</el-col>
						<el-col :xs="24" :sm="8">
							<!-- 包装盒数量 -->
							<el-form-item 
							  :label="'포장박스수량'"
							  :prop="`items.${index}.box_count`"
							>
								<div class="flex">
									<el-input-number v-model="item.box_count" :min="1" :precision="0" :controls="false" class="num-input-left" style="width: 100%;"></el-input-number>
									<el-popover placement="top" width="300" trigger="hover" >
										<div>
											판매자가 발송한 총 박스수량 을 입력해주세요
										</div>
										<i class="el-icon-question icon-question"  slot="reference"></i>
									</el-popover>
								</div>
							</el-form-item>
						</el-col>
						<el-col :xs="24" :sm="8">
							<!-- 数量 -->
							<el-form-item 
							  :label="'수량'"
							  :prop="`items.${index}.apply_quantity`"
							  :rules="[
								{ required: true, message: '수량 필수', trigger: 'blur' },
							  ]"
							>
								<div class="flex">
									<el-input-number v-model="item.apply_quantity" :min="1" :precision="0" :controls="false" class="num-input-left" style="width: 100%;"></el-input-number>
									<div style="padding-left: 5px;" >개</div>
								</div> 
							</el-form-item>
						</el-col>
						<el-col :xs="24" :sm="8">
							<!-- 商品代码 -->
							<el-form-item 
							  :label="'상품코드'"
							  :prop="`items.${index}.refer_code`"
							>
								<div class="flex">
									<el-input v-model="item.refer_code"  clearable ></el-input>
									<el-popover placement="top" width="300" trigger="hover" >
										<div>
											국내마켓 상품관리에 필요한 상품코드를 입력 관리해보세요
										</div>
										<i class="el-icon-question icon-question"  slot="reference"></i>
									</el-popover>
								</div>
							</el-form-item>
						</el-col>
						<el-col :xs="24" :sm="8">
							<!-- 商品url -->
							<el-form-item 
							  :label="'상품 URL'"
							  :prop="`items.${index}.url`"
							  :rules="[
							  		{ required: true, message: '상품 URL 필수', trigger: 'blur' },
									{ type: 'url', message: '올바른 URL 형식이 아닙니다', trigger: 'blur' }
							  ]"
							>
								<div class="flex">
									<el-input v-model="item.url"  clearable ></el-input>
								</div>
							</el-form-item>
						</el-col>
						<el-col :xs="24" :sm="8">
							<!-- 发货备注 -->
							<el-form-item 
							  :label="'요청메세지'"
							  :prop="`items.${index}.shipping_memo`"
							>
								<div class="flex">
									<el-input v-model="item.shipping_memo" placeholder="로켓크로스 요청사항, 원산지증명서 C/O 옵션 선택 시, HS코드를 입력해 주세요." clearable ></el-input>
								</div>
							</el-form-item>
						</el-col>
						<!-- <el-col :xs="24" :sm="12" v-if="deliveryCenterCode != 'CN_LCL'">
						<div style="margin: 10px 0 10px 20px;">
							
							<el-checkbox v-model="item.origin">원산지작업(유료)</el-checkbox>
							
							<el-checkbox v-model="item.package">포장보완(유료)</el-checkbox>
							
							<el-checkbox v-model="item.check">정밀검수(유료)</el-checkbox>
						</div>
						</el-col> -->

						<!--부가서비스 신청 버튼 - 单独一行-->
						<el-col :xs="24" :sm="24">
							<div style="margin: 0 0 20px 20px; display: flex; align-items: center; flex-wrap: wrap;">
								<el-button type="primary" size="mini" plain icon="el-icon-setting" @click="openExtraServicesDialog(index)">
									부가서비스 신청
								</el-button>
								<div v-if="hasSelectedExtraServices(item)" style="margin-left: 15px; font-size: 12px; color: #666; line-height: 1.6;">
									<strong style="color: #ff5700;font-size:15px;">신청한 부가 서비스: </strong>
									<span style="font-weight: 500; color: #333;">{{ formatSelectedExtraServices(item) }}</span>
								</div>
							</div>
						</el-col>

					</el-row>
					
					
					<!--上传图像-->
					<el-dialog
					  title="이미지 등록" :width="isMobile?'90%':'30%'"
					  :visible.sync="uploadVisible" center @close="onCloseUpload">
						<el-radio-group v-model="upload" size="mini" @change="changeUpload">
						  <el-radio :label="1" style="margin-bottom: 10px;">이미지 직접 업로드</el-radio>
						  <el-radio :label="2" style="margin-bottom: 10px;">이미지 URL 등록</el-radio>
						</el-radio-group>
						<div v-if="upload==1">
						  <el-upload
							class="avatar-uploader"
							:action="update_url+'/common/upload'"
							:show-file-list="false"
							:on-success="handleAvatarSuccess"
							:before-upload="beforeAvatarUpload">
							  <el-image v-if="imageUrl"
								  class="avatar"
								  :src="imageUrl"
								  fit="cover"></el-image>
							  <el-button size="small" plain type="primary">업로드 클릭</el-button>
						  </el-upload>
						</div>
						<div v-else>
						  <el-input v-model="imageUrl" placeholder="URL은 http포함해서 입력해 주세요."></el-input>
						</div>
					  <span slot="footer" class="dialog-footer">
						<el-button v-if="upload == 2" type="primary" @click="submitUpload">등록하기</el-button>
					  </span>
					</el-dialog>

					<!-- 商品分类弹框 已改为下拉 Popover -->
					<!-- 不可空运商品指南 弹框 -->
					<el-dialog title="" :visible.sync="AirVisible" :width="isMobile?'96%':'50%'" :close-on-click-modal="false" :close-on-press-escape="false" >
						<div class="air-popup-content">
							<h2>항공선적 불가상품 안내</h2>
							<el-row>
								<el-col :xs="24" :sm="12" style="padding:0 5px;">
									<div class="category-title">01. 전자제품류</div>
									<ul class="dot-list">
										<li>● 휴대폰</li>
										<li>● 태블릿 PC</li>
										<li>● 전자담배</li>
										<li>● 단독 및 보조배터리, 배터리가 포함된 제품들</li>
										<li>● 이어폰</li>
										<li>● 시계류</li>
										<li>● 각종 배터리(건전지 등)가 포함된 제품</li>
										<li>● 모터</li>
										<li>● 블루투스 기능이 있는 제품</li>
										<li>● 전선류, 콘센트 등 기타 모든 전자제품류</li>
									</ul>
								</el-col>
								<el-col :xs="24" :sm="12" style="padding:0 5px;">
									<div class="category-title">02. 액체류</div>
									<ul class="dot-list">
										<li>● 화장품</li>
										<li>● 방향제</li>
										<li>● 인화성 액체(휘발유, 석유, 라이터 연료, 페인트 등)</li>
										<li>● 아세톤 등 화기물품</li>
										<li>● 기타 모든 액체류</li>
									</ul>
								</el-col>
								<el-col :xs="24" :sm="12" style="padding:0 5px;">
									<div class="category-title">03. 장난감류</div>
									<ul class="dot-list">
										<li>● 장난감 총</li>
										<li>● 검</li>
										<li>● 활</li>
										<li>● 무기류(플라스틱 재질 포함)</li>
									</ul>
								</el-col>
								<el-col :xs="24" :sm="12" style="padding:0 5px;">
									<div class="category-title">04. 화학류</div>
									<ul class="dot-list">
										<li>● 방사성 물질</li>
										<li>● 가연성 물질(성냥, 촛 등)</li>
										<li>● 화약, 폭약류</li>
										<li>● 폭발물류</li>
										<li>● 독극물류(살충제, 농약 등)</li>
										<li>● 인화물</li>
										<li>● 생활화학 물질</li>
										<li>● 고압가스 포함 제품류(스프레이, 부탄가스, 소화기 등)</li>
									</ul>
								</el-col>
								<el-col :xs="24" :sm="12" style="padding:0 5px;">
									<div class="category-title">05. 기타</div>
									<ul class="dot-list">
										<li>● 동, 식물</li>
										<li>● 자동차 부품</li>
										<li>● 식품류</li>
										<li>● 건강보조제</li>
										<li>● 분말류</li>
										<li>● 자석류</li>
										<li>● 세변의 합 140cm 이상 혹은 한 변의 길이 100cm 이상 상품</li>
										<li>● 구성품에 포함된 본드/액체 등 모든 항공선적불가품</li>
									</ul>
								</el-col>
							</el-row>
							<strong>
							    위 상품들은 항공선적이 절대 불가하오니 반드시 참고하시어 신청서 작성 바랍니다.
							</strong>
							<div style="text-align: center;">
								<div class="link-btn type-2" @click="onCurrentNav('')">
									항공선적불가 바로가기 <i class="el-icon-top-right"></i>
								</div>
							</div>
							<p class="popup-desc text-center">항공선적불가상품으로 신청 시 선적불가상품으로 인해(상품류 또는 패키지/출고 규격) 등이 발생할 수 있으며<br>
							   상품의 고로켓고 중국물류센터 리턴 시 착불 비용이 청구되며, 기타 추가 비용이 청구될 수 있습니다.<br>
								구매상품 총$2.000(달러) 이상 항공으로 진행시, 세관 창고료가 발생 될수 있음을 안내 드립니다<br><br>
								기타 문의사항은 고객센터로 부탁드리겠습니다.
							</p>
						</div>
					</el-dialog>

					

					
				  </div>
				  
				  <!-- <div class="customs-real-price">
		
					  <div class="box">
						  <div class="title">현지 세금</div>
						  <div class="input-group">
							  <el-input v-model="sales_tax"></el-input>
							  <div class="input-group-addon">CNY</div>
						  </div>
					  </div>
			
					  <div class="box">
						  <div class="title">현지 배송비</div>
						  <div class="input-group">
							  <el-input v-model="shipping"></el-input>
							  <div class="input-group-addon">CNY</div>
						  </div>
					  </div>
			
					  <div class="box">
						  <div class="title">할인 금액</div>
						  <div class="input-group">
							  <el-input v-model="discount"></el-input>
							  <div class="input-group-addon">CNY</div>
						  </div>
					  </div>
					  <div class="box total">
						  <div class="title">상품 단가 반영</div>
						  <div style="text-align: center;padding-top: 10px;">
							  <el-button type="primary" @click="calcAmount">반영하기</el-button>
						  </div>
					  </div>
					  <p class="explain">
						* 구매비용은 세관에 신고되는 상품가격이기 때문에 <span class="color-blue">고객님께서 결제하신 금액과 일치</span> 해야 합니다.<br>
						* 현지 세금, 현지 배송비, 할인 금액을 입력하는 경우 <span class="color-blue">단가에 반영하기 버튼을 눌러야 적용되므로,</span> 상품 정보를 모두 입력 후 반영하기를 눌러주세요.
					  </p> 
				  </div> -->
				  
				  <div class="customs-after-box" v-if="!isMobile">
					<div class="customs">
						<strong>
						목록통관으로 진행됩니다.
						</strong>
						<a href="/bizCustomsInfo" target="_blank" class="btn btn-submit">통관안내</a>
					</div>						  
				 
					<div class="after">
						  <div class="total-price">
							  총 상품금액 :
							  <span id="customs-real-price">¥{{totalAmount.toFixed(2)}}</span>
						  </div>
					</div> 
				  </div>
				  <div class="customs-after-box" v-else>
					  <div class="customs">
						  <strong>
							  목록통관으로 진행됩니다.
						  </strong>
							<a href="/bizCustomsInfo" target="_blank" class="btn btn-submit">통관안내</a>
					  </div>
					  <div class="after">
						  <div class="total-price">
							  총 상품금액 :
							  <span id="customs-real-price">¥{{totalAmount.toFixed(2)}}</span>
						  </div>
					  </div>
				  </div>
				  
				  <div class="type-card shadow-all">
					<div class="card-head">
					    부가서비스 신청 내역
					</div>
					<div class="card-body">
						<div class="card-help">
							부가서비스 상세내역을 꼭! 확인하세요.
							<a href="/bizAddService" class="type-1 link-btn" style="width: 100px;" target="_blank">
							바로가기<i class="el-icon-top-right"></i>
							</a>
						</div>
						<el-row class="col-wrap">
							<el-col :xs="24" :sm="8">
								<div class="group">
									<h4>제거</h4>
									<el-checkbox-group v-model="formData.data.remove" @change="onCheck" >
										
										<label class="checkbox-inline" v-for="(item,index) in agency_attach.remove" :key="index" >
											<el-checkbox :label="item.id" >{{item.name}}
												<el-popover
														placement="top"
														width="420"
														trigger="hover"
														>
														<div style="padding:10px 20px;" v-html="item.remarks"></div>
														<i class="el-icon-question icon-question"  slot="reference"></i>
												</el-popover>
											</el-checkbox>
											<span>{{item.subtitle}}</span>
										</label>
										
										
									</el-checkbox-group>
								</div>
								<div class="group">
									<h4>검수</h4>							
									<el-radio-group v-model="formData.data.check_level" style="width: 100%;" >
										<label class="checkbox-inline" v-for="(item,index) in agency_attach.check_level" :key="index">
											<el-radio :label="item.id" >{{item.name}}
												<el-popover
														placement="top"
														width="400"
														trigger="hover"
														>
														<div style="padding:10px 20px;" v-html="item.remarks"></div>
														<i class="el-icon-question icon-question"  slot="reference"></i>
												</el-popover>
											</el-radio>
											<span>{{item.subtitle}}</span>
										</label>
									</el-radio-group>

								</div>
								
							</el-col>
							<el-col :xs="24" :sm="8" >
								<div class="group">
									<h4>포장</h4>
									<el-radio-group v-model="formData.data.packing_level" style="width: 100%;" >
										<label class="checkbox-inline" v-for="(item,index) in agency_attach.packing_level" :key="index">
											<el-radio :label="item.id" >{{item.name}}
												<el-popover
														placement="top"
														width="400"
														trigger="hover"
														>
														<div style="padding:10px 20px;" v-html="item.remarks"></div>
														<i class="el-icon-question icon-question"  slot="reference"></i>
												</el-popover>
											</el-radio>
											<span>{{item.subtitle}}</span>
										</label>		
									</el-radio-group>
									<el-checkbox-group v-model="formData.data.add_packing" >
										<label class="checkbox-inline" v-for="(item,index) in agency_attach.add_packing" :key="index">
											<el-checkbox :label="item.id" >{{item.name}}
												<el-popover
														placement="top"
														width="400"
														trigger="hover"
														>
														<div style="padding:10px 20px;" v-html="item.remarks"></div>
														<i class="el-icon-question icon-question"  slot="reference"></i>
												</el-popover>
											</el-checkbox>
											<span>{{item.subtitle}}</span>
										</label>			
									</el-checkbox-group>
								</div>
							</el-col>
							<el-col :xs="24" :sm="8" >
								<div class="group">
									<h4>기타</h4>
									<el-checkbox-group v-model="formData.data.template" >
										<div style="display: flex;align-items: center;" v-for="(item,index) in agency_attach.template" :key="index" >
											<label class="checkbox-inline checkbox-inline-margin" style="width:80%;">
												<el-checkbox :label="item.id" >{{item.name}}
													<el-popover
															placement="top"
															width="400"
															trigger="hover"
															>
															<div style="padding:10px 20px;" v-html="item.remarks"></div>
															<i class="el-icon-question icon-question"  slot="reference"></i>
													</el-popover>
												</el-checkbox>
												<span>{{item.subtitle}}</span>
											</label>
											<el-input v-model="formData.data[`template${item.id}_cnt`]" style="width:20%;margin-top: 10px;">
												<template slot="suffix">개</template>
											</el-input>
										</div>

									</el-checkbox-group>
									<el-checkbox-group v-model="formData.data.customs" >
										<label class="checkbox-inline" style="width: 100%;" v-for="(item,index) in agency_attach.customs" :key="index">
											<el-checkbox :label="item.id" >{{item.name}}
												<el-popover
														placement="top"
														width="400"
														trigger="hover"
														>
														<div style="padding:10px 20px;" v-html="item.remarks"></div>
														<i class="el-icon-question icon-question"  slot="reference"></i>
												</el-popover>
											</el-checkbox>
											<span>{{item.subtitle}}</span>
										</label>				
									</el-checkbox-group>
								</div>
							</el-col>
						</el-row>
						
						<div class="card-help text-center bottom">
							아이템별 정밀검수, 포장보완, 원산지 작업은 상단 신청서 입력란에서 선택해주세요.
						</div>
						
					</div>  
				  </div>
				  
				  <div class="type-card shadow-all">
					<div class="card-head">
						배송지 정보 입력
					</div>
					<div class="card-body">
						<div class="card-help">
							상품을 받으실 수취인 정보를 입력해 주세요.
							<p class="normal" style="margin-bottom: 10px;">
							(수입신고자 명의로 통관을 진행하기 때문에 본인외에 수취인 정보를 입력할 경우, 세관에서 관계증명서 및 사유서 제출을 요구할 수 있습니다.)
							</p>
							외국인의 경우 <span class="color-red">[한글수취인명]</span> 입력란에도 <span class="color-red">여권상의 영문 이름</span>을 입력해주세요.<br>
							<!-- Đối với người nước ngoài, vui lòng nhập tên tiếng Anh trên hộ chiếu vào ô nhập <span class="color-red">[한글수취인명]</span>                     -->
						</div>
						
						<el-button type="primary" @click="openAddress" round>배송지 주소록</el-button>
						
						<div style="margin:30px 0;">
							<el-descriptions title="" direction="vertical" :column="4" border>
								  <el-descriptions-item label="수취인명">{{address_info.consignee}}</el-descriptions-item>
								  <el-descriptions-item label="연락처">{{address_info.mobile}}</el-descriptions-item>
								  <el-descriptions-item label="	개인통관고유부호" >{{address_info.customs_info}}</el-descriptions-item>
								  <el-descriptions-item label="우편번호">{{address_info.zipcode}}</el-descriptions-item>
								  <el-descriptions-item label="주소">{{address_info.address}} {{address_info.detailed_address}}</el-descriptions-item>
							</el-descriptions>
						</div>
						<el-row>
							<el-col :xs="24" :sm="4" class="background-color">국내 택배사 요청사항</el-col>
							<el-col :xs="24" :sm="20">
								<el-input v-model="formData.data.express_demand" maxlength="30" placeholder="30자 이내로만 입력할 수 있습니다."></el-input>
							</el-col>							
						</el-row>
					
						

					</div>
				  </div>
				  
				  <div class="type-card shadow-all">
						<div class="card-head">
							세부 정보 설정
						</div>
						<div class="card-body">
							<el-row class="col-wrap">
								<el-col :xs="24" :sm="5">
									<div class="group">
										<h4>결제 옵션</h4>
										<el-checkbox-group v-model="formData.data.pay_service">
											<label class="checkbox-inline">
												<el-checkbox label="1" > 자동배송 요청</el-checkbox>
											</label>
											<label class="checkbox-inline">
												<el-checkbox label="2" > 로켓머니</el-checkbox>
											</label>
										</el-checkbox-group>
									</div>
								</el-col>
								<el-col :xs="24" :sm="9">
									<div class="group">
										<h4>선/착불 구분
											<el-popover
													placement="top"
													width="410"
													trigger="hover"
													>
													<ul class="dot-list">
														<li style="font-size: 13px;font-weight: 400;" >● [경동착불]: 경동 인계 사이즈가 아닐 경우<br>국내 일반 택배사로 정상 인계되는 점 안내드리겠습니다.</li>
														<li style="font-size: 13px;font-weight: 400;">● [경동선불]: 통관 후, 경동 택배 선불로 발송됩니다.<br>(주의: 경동 인계 사이즈 미달이나 선택할 경우 경동 비용발생.)</li>
														<li style="font-size: 13px;font-weight: 400;">● [화물차]: 통관 후, 화물차로 단독 발송됩니다.</li>
														<li style="font-size: 13px;font-weight: 400;">● ※ 경동/화물 인계의 경우 별도의 국내 배송 비용이 발생됩니다.</li>
													</ul>
													<i class="el-icon-question icon-question"  slot="reference"></i>
											</el-popover>
										</h4>
										<el-radio-group v-model="formData.data.service_cargo_type" @input="onCargoType" style="display: flex;" >
											<label class="checkbox-inline">
												<el-radio label='1' >경동 선불</el-radio>
											</label>
											<label class="checkbox-inline">
												<el-radio label='2' >경동 착불</el-radio>
											</label>
											<label class="checkbox-inline">
												<el-radio label='3' >화물차</el-radio>
											</label>
										</el-radio-group>
										
									</div>	
								</el-col>
								<el-col :xs="24" :sm="5">
									<div class="group">
										<h4>FTA 세율 적용 여부
											<el-popover
													placement="top"
													width="400"
													trigger="hover"
													>
													<ul class="dot-list">
														<li style="font-size: 13px;font-weight: 400;" >● 한중 FTA 협정 세율 적용 $700 이하 수입 시 원산지증명서를 제출해 주셔야합니다.<br>[부가서비스-기타-원산지 증명서 C/O 옵션 선택바랍니다.]</li>
														<li style="font-size: 13px;font-weight: 400;"><a href="" target="_blank">[주의사항 바로가기]</a></li>
													</ul>
													<i class="el-icon-question icon-question"  slot="reference"></i>
											</el-popover>
										</h4>
										<el-radio-group v-model="formData.data.service_fta_type" style="display: flex;" >
											<label class="checkbox-inline">
												<el-radio label='1' >적용</el-radio>
											</label>
											<label class="checkbox-inline">
												<el-radio label='2' >미적용</el-radio>
											</label>
									
										</el-radio-group>
									</div>
									
								</el-col>
								<el-col :xs="24" :sm="5">
									<div class="group">
										<h4>관부가세 안내</h4>
										<el-radio-group v-model="formData.data.service_tariff_notify" style="display: flex;" >
											<label class="checkbox-inline">
												<el-radio label='1' >송하인</el-radio>
											</label>
											<label class="checkbox-inline">
												<el-radio label='2' >수령인</el-radio>
											</label>									
										</el-radio-group>
									</div>
									
								</el-col>
							</el-row>
							
						</div>
					</div>
					
					<div class="caution-box">
							<div>● 1개의 배송신청서 상 서로 다른 트래킹 번호 5 (가지)까지 무료<br>
								1개의 배송신청서 상 서로 다른 트래킹 번호 5 (가지) 초과 시, 추가된 트래킹번호 1가지 당 500원 청구</div>
							<div>● 항공선적 불가상품을 항공배송으로 신청 시 선적불가상품으로 인해 (상품압류 또는 폐기/출고불가)등이 발생할 수 있으며<br>
								상품이 고로켓고 중국물류센터로 리턴 시 착불 비용이 청구되며, 기타 추가 비용이 청구될 수 있습니다.</div>
							<div>● 국내 택배사 집하 거부로 유리제품, 도자기 류, 모니터 류, 가구 류는 국내 배송 파손 시 택배사 면책을 동의해야 출고 가능합니다.</div>
							<div>● 합포장·합배송 상품의 원포장자재가 부실할 경우 포장자재 신청해주셔야 합니다.</div>
							<div>● 포장자재 신청이 없을 경우 원포장으로 발송하며 이 경우 상품 혹은 구성품의 분실이 발생할 수 있으며 이 경우 고로켓고의 과실이 아닙니다.</div>
							<div>● 상품이 고로켓고 중국 물류센터 도착 후 현지 물동량에 따라 평균 입고/검수 1일이내, 배송요청 후 평균 1일 이내 포장완료되어 배송비 결제요청됩니다.<br>
								(단일상품은 입고, 검수, 포장, 발송까지 평균 1일 소요)</div>
							<div>● 신청서는 작성하신 내용 그대로 세관에 신고되므로, 허위 신고로 인한 모든 책임은 작성자 본인에게 있습니다.</div>
							<div>● 고로켓고 검수완료후 도착사진을 반드시 직접 확인하셔서 상품의 이상유무를 확인해 주셔야합니다.</div>
							<div>● 배송신청을 하실 경우 도착상품의 이상유무를 직접 확인하신 것으로 판단하여 출고되며 추후 검수미비로 인한 보상은 해당되지 않습니다.</div>	
					</div>
					<div class="caution-agree">
						<div class="checkbox">
							<label >
								<el-checkbox v-model="formData.data.is_agree">모든 작성사항을 확인하였으며 주의사항에 동의합니다.</el-checkbox>
							</label>
						</div>
					</div>
					
				  
				  <el-dialog title="배송지 주소록" :width="isMobile?'90%':'50%'" :visible.sync="addressVisible">
					<template v-if="address_total>0">
						<strong>전체 : {{address_total}}</strong>
						<el-table
						  :data="addressData" :show-header="false"
						  style="padding: 0 10px;width: 100%;margin-bottom: 20px;height: 400px; overflow: auto;  ">
							  <el-table-column
							    label="">
								<template slot-scope="scope">
								  <p>{{ scope.row.consignee }}</p>
								  <p>개인통관고유부호:{{ scope.row.customs_info }}</p>
								  <p>{{ scope.row.mobile }}</p>
								  <p>[{{scope.row.zipcode}}] {{scope.row.address}} {{scope.row.detailed_address}}</p>
								</template>	
							  </el-table-column>
							<el-table-column   
							    label="操作"
							    width="80">
							    <template slot-scope="scope">
							      <el-button  @click="selAddress(scope.row)" type="text" size="small">선택</el-button><br>
							    </template>
							</el-table-column>	
						</el-table>
					</template>
					<el-button v-else type="primary" @click="onNewNav('/addressBook')" round>배송지 주소록 등록</el-button>
					
				  </el-dialog>
				<!-- 상품 개별 부가서비스 설정 모달 -->
				<el-dialog
				  title="상품 부가서비스 신청"
				  :visible.sync="extraServiceDialogVisible"
				  :close-on-click-modal="false"
				  :close-on-press-escape="false"
				  :width="isMobile ? '95%' : '65%'"
				  center>
				  <div class="type-card" v-if="currentExtraItem" style="box-shadow: none; border: none; margin-bottom: 0;">
					<div class="card-body" style="padding: 0px 10px;">
						<el-row class="col-wrap">
							<el-col :xs="24" :sm="8">
								<div class="group">
									<h4>제거</h4>
									<el-checkbox-group v-model="currentExtraItem.remove">
										<label class="checkbox-inline" v-for="(subItem, subIndex) in agency_attach.remove" :key="subIndex" > 
											<el-checkbox :label="subItem.id" >{{subItem.name}}  
												<el-popover
														placement="top"
														width="420"
														trigger="hover"
														>
														<div style="padding:10px 20px;" v-html="subItem.remarks"></div>
														<i class="el-icon-question icon-question"  slot="reference"></i>
												</el-popover>
											</el-checkbox>
											<span>{{subItem.subtitle}}</span>
										</label>
									</el-checkbox-group>
								</div>
								<div class="group">
									<h4>검수</h4>							
									<el-radio-group v-model="currentExtraItem.check_level" style="width: 100%;" >
										<label class="checkbox-inline" v-for="(subItem, subIndex) in agency_attach.check_level" :key="subIndex">
											<el-radio :label="subItem.id" >{{subItem.name}}
												<el-popover
														placement="top"
														width="400"
														trigger="hover"
														>
														<div style="padding:10px 20px;" v-html="subItem.remarks"></div>
														<i class="el-icon-question icon-question"  slot="reference"></i>
												</el-popover>
											</el-radio>
											<span>{{subItem.subtitle}}</span>
										</label>
									</el-radio-group>
								</div>
							</el-col>
							<el-col :xs="24" :sm="8" >
								<div class="group">
									<h4>포장</h4>
									<el-radio-group v-model="currentExtraItem.packing_level" style="width: 100%;" >
										<label class="checkbox-inline" v-for="(subItem, subIndex) in agency_attach.packing_level" :key="subIndex">
											<el-radio :label="subItem.id" >{{subItem.name}}
												<el-popover
														placement="top"
														width="400"
														trigger="hover"
														>
														<div style="padding:10px 20px;" v-html="subItem.remarks"></div>
														<i class="el-icon-question icon-question"  slot="reference"></i>
												</el-popover>
											</el-radio>
											<span>{{subItem.subtitle}}</span>
										</label>		
									</el-radio-group>
									<el-checkbox-group v-model="currentExtraItem.add_packing" >
										<label class="checkbox-inline" v-for="(subItem, subIndex) in agency_attach.add_packing" :key="subIndex">
											<el-checkbox :label="subItem.id" >{{subItem.name}}
												<el-popover
														placement="top"
														width="400"
														trigger="hover"
														>
														<div style="padding:10px 20px;" v-html="subItem.remarks"></div>
														<i class="el-icon-question icon-question"  slot="reference"></i>
												</el-popover>
											</el-checkbox>
											<span>{{subItem.subtitle}}</span>
										</label>			
									</el-checkbox-group>
								</div>
							</el-col>
							<el-col :xs="24" :sm="8" >
								<div class="group">
									<h4>기타</h4>
									<el-checkbox-group v-model="currentExtraItem.template" >
										<div style="display: flex;align-items: center;" v-for="(subItem, subIndex) in agency_attach.template" :key="subIndex" >
											<label class="checkbox-inline checkbox-inline-margin" style="width:80%;">
												<el-checkbox :label="subItem.id" >{{subItem.name}}
													<el-popover
															placement="top"
															width="400"
															trigger="hover"
															>
															<div style="padding:10px 20px;" v-html="subItem.remarks"></div>
															<i class="el-icon-question icon-question"  slot="reference"></i>
													</el-popover>
												</el-checkbox>
												<span style="white-space: nowrap;">{{subItem.subtitle}}</span>
											</label>
											<el-input v-model="currentExtraItem[`template${subItem.id}_cnt`]" style="width:20%;margin-top: 10px;">
												<template slot="suffix">개</template>
											</el-input>
										</div>
									</el-checkbox-group>
									<el-checkbox-group v-model="currentExtraItem.customs" >
										<label class="checkbox-inline" style="width: 100%;" v-for="(subItem, subIndex) in agency_attach.customs" :key="subIndex">
											<el-checkbox :label="subItem.id" >{{subItem.name}}
												<el-popover
														placement="top"
														width="400"
														trigger="hover"
														>
														<div style="padding:10px 20px;" v-html="subItem.remarks"></div>
														<i class="el-icon-question icon-question"  slot="reference"></i>
												</el-popover>
											</el-checkbox>
											<span>{{subItem.subtitle}}</span>
										</label>				
									</el-checkbox-group>
								</div>
							</el-col>
						</el-row>
					</div>
				  </div>
				  <span slot="footer" class="dialog-footer">
					<el-button type="danger" plain round @click="clearCurrentExtraItemServices" style="margin-right: 10px;">모두 지우기</el-button>
					<el-button type="primary" round @click="extraServiceDialogVisible = false">확인</el-button>
				  </span>
				</el-dialog>

				<el-dialog
				  :visible.sync="centerDialogVisible" :close-on-press-escape="false" :close-on-click-modal="false"
				  :width="isMobile?'90%':'50%'" 
				  @close="onCloseImport"
				  center>
				  <div>
						<div class="section-header">
							<h1><span>타오바오/1688</span> 주문서 자동등록</h1>
							<p>중국 쇼핑몰의 장바구니 주문 상세 내역을 전체 복사(Ctrl+C)하여 하단의 빈칸에 [붙여넣기] 해주세요.<br>
							붙여넣기(Ctrl+V)하신 후 가져오기 버튼을 눌러주세요</p>
							<!-- <a href="/deliveryAuto" target="_blank"><img src="../../assets/icon/info-icon.png" alt="자동등록 이용방법">자동등록 이용방법</a> -->
						</div>
						<el-select v-model="site_value" @change="changeSite" placeholder="">
						    <el-option
						      v-for="item in options"
						      :key="item.value"
						      :label="item.label"
						      :value="item.value">
						    </el-option>
						</el-select>
						<!-- 核心：可编辑的 div -->
						<div  @paste="handlePaste" ref="handlePaste"  contenteditable="true" style="margin-top: 10px; height: 200px;  overflow-y: auto;  border: 1px solid #ddd; border-radius: 10px; padding: 10px;">
						   <!-- 在这里粘贴或输入富文本内容 -->
						</div>
							
				  </div>
				  <span slot="footer" class="dialog-footer" >
				    <el-button round @click="onCloseImport">닫기</el-button>
				    <el-button style=" background:#ff5700;color:#FFF;" round @click="onImportOrder">가져오기</el-button>
				  </span>
				</el-dialog>
				
				</el-form>
				
				
				
				<div class="text-center">
					<el-button @click="onReturn" round>뒤로가기</el-button>
					<el-button
					  type="primary" 
					  @click="submitForm" round
					  style="margin-left: 30px"
					>
					  수정하기
					</el-button>
				</div>
				
				
				
			</div>
			<el-empty v-else description="매개변수 오류"></el-empty>
			
				
		</div>
		
	
	
	
	</div>
</template>

<script>
	import AgencyBanner from '../../components/AgencyBanner.vue'
	import { safePush } from '@/utils/router';
	import request from '@/utils/request';
	import Constants from '@/constants'
	import categoryData from '@/assets/fenlei_final_with_10_names_no_cat4.min.json'
	export default {
	  //name: 'DynamicForm',
		components: {
			AgencyBanner,
		},
		data() {
			return {
				AirVisible: false,
				 
				CategoryVisible: false,
				category_index:'',
				category_list:[],
				search: '',
				flattenedCategories: [],
				categorySearch: '',
				centerDialogVisible: false,
				options: [{
				  value: '',
				  label: 'totalSupport'
				}, {
				  value: '1688',
				  label: '阿里巴巴'
				}, {
				  value: 'taobao',
				  label: '淘宝网'
				}],
				site_value: '',
				pasted_html: '',
				uploadVisible:false,
				upload:1,
				update_url:'',
				imageUrl:'',
				imageIndex:-1,
				extraServiceDialogVisible: false,
				currentExtraServiceItemIndex: '',
				
				// sales_tax:'',
				// shipping:'',
				// discount:'',
				agency_attach:[],
				//total_amount:998.90,
			  // 表单数据模型
			  formData: {
				items: [], // 动态表单项数组
				data:{	
					remove:[],
					check_level:5,
					packing_level:6,
					add_packing:[],
					template:[],
					template15_cnt:1,
					template16_cnt:1,
					template17_cnt:1,
					template18_cnt:1,
					template19_cnt:1,
					template20_cnt:1,
					template21_cnt:1,
					customs:[],
					address_id:'',
					express_demand:'',
					pay_service:['2'],
					service_cargo_type:'2',
					service_fta_type:'2',
					service_tariff_notify:'2',
					service_delivery_notify:'2',
					is_agree:'',
				}
				
			  },
			  
			  show:"",
			  agreement_yn:"",
			  deliveryCenterCode:"",
			  customsType:"",
			  customsTypeName:"",
				addressData: [],
				addressVisible: false,
				address_info:{},
				address_total:0,
			}
		},
		created() {
			const id = this.$route.query.id;
			if (!id) {
				this.$message.error('주문 ID가 없습니다.');
				this.show = false;
				return;
			}
			console.log("Edit Mode for ID:", id);
			this.getAgencyAttach().then(() => {
				this.loadAgencyDetail(id);
			}).catch(() => {
				this.loadAgencyDetail(id);
			});
		},
		computed: {
			/**
			* 计算总金额：所有商品的（单价 × 数量）之和
			*/
			totalAmount() {
				return this.formData.items.reduce((sum, goods) => {
				// 处理未输入的情况（默认0）
				const price = Number(goods.price) || 0
				const quantity = Number(goods.apply_quantity) || 0
				return sum + (price * quantity)
			}, 0)
			},
			filteredCategories() {
				if (!this.categorySearch) {
					return this.flattenedCategories
				}
				const query = this.categorySearch.toLowerCase()
				return this.flattenedCategories.filter(item => {
					return (
						(item.l1 && item.l1.toLowerCase().includes(query)) ||
						(item.l2 && item.l2.toLowerCase().includes(query)) ||
						(item.l2_code && item.l2_code.toLowerCase().includes(query)) ||
						(item.l2_cn && item.l2_cn.toLowerCase().includes(query)) ||
						(item.l2_en && item.l2_en.toLowerCase().includes(query)) ||
						(item.l3 && item.l3.toLowerCase().includes(query)) ||
						(item.l3_code && item.l3_code.toLowerCase().includes(query))
					)
				})
			},
		  isMobile() {
			return window.innerWidth <= 768;
		  },
		  currentExtraItem() {
			if (this.currentExtraServiceItemIndex !== '' && this.currentExtraServiceItemIndex !== null && this.currentExtraServiceItemIndex !== undefined) {
				return this.formData.items[this.currentExtraServiceItemIndex];
			}
			return null;
		  }
		},
		mounted() {
			this.update_url = Constants.BASE_URL
		},
		methods: {
			handlePaste(e) {
				const clipboardData = e.clipboardData || window.clipboardData;
				if (!clipboardData) return;
				const html = clipboardData.getData('text/html');
				if (html) {
					e.preventDefault();
					this.pasted_html = html;
					this.$refs.handlePaste.innerHTML = html;
				}
			},
			onCloseImport() {
				this.pasted_html = '';
				if (this.$refs.handlePaste) this.$refs.handlePaste.innerHTML = '';
				this.centerDialogVisible = false;
			},
			changeSite(value) {
				this.site_value = value;
			},
			onImportOrder() {
				const html = this.pasted_html || (this.$refs.handlePaste ? this.$refs.handlePaste.innerHTML : '');
				if (!html) {
					this.$message.warning("붙여넣은 내용이 없습니다.");
					return;
				}
				const parser = new DOMParser();
				const doc = parser.parseFromString(html, 'text/html');

				// 获取所有容器类 (包含淘宝和1688购物车行结构)
				let nodes = Array.from(doc.querySelectorAll(".trade-cart-item-info, [class*='cartItemInfo--'], .trade-bought-list-order-info, .J_ItemBody, .cart-item, .item-content, .item-basic-info, [class*='item-content'], [class*='cart-item'], [class*='ItemBody'], .item--container--SrhZkVY, [class*='item--container--']"));
				if (nodes.length === 0) {
					// 兜底逻辑
					const imgs = doc.querySelectorAll('img');
					const found = [];
					imgs.forEach(img => {
						let p = img.parentElement;
						let steps = 0;
						while (p && steps < 6) {
							const txt = p.textContent || '';
							if ((txt.includes('¥') || txt.includes('￥')) && txt.length > 20) {
								found.push(p);
								break;
							}
							p = p.parentElement;
							steps++;
						}
					});
					nodes = [...new Set(found)];
				}

				// 过滤掉所有嵌套子节点，只保留最外层的父节点以防止重复解析商品
				nodes = nodes.filter(n => !nodes.some(other => other !== n && other.contains(n)));

				if (nodes.length === 0) {
					this.$message.error("상품 정보를 파싱하지 못했습니다. HTML 구조가 올바른지 확인해주세요.");
					return;
				}

				const groupPriceMap = new Map();
				const items = [];
				for (let i = 0; i < nodes.length; i++) {
					const node = nodes[i];
					// 如果是空的则跳过
					if (!node.textContent.trim()) continue;

					// 判断是否是 1688 购物车行 (比如含有 class 包含 item--container)
					let is1688Cart = node.classList.contains('item--container--SrhZkVY') || node.matches("[class*='item--container--']");

					// 提取各字段信息
					let price = "0.00";
					let goodsName = "";
					let imageUrl = "";
					let apply_quantity = 1;
					let color = "";
					let size = "";
					let url = "";

					if (is1688Cart) {
						// === 1688 专属解析逻辑 ===
						// 1. 优先解析数量 (因为后面的价格兜底需要用到数量计算)
						// 1688 使用 next-number-picker 组件，复制时 value 属性可能未同步
						let qtyFound = false;
						// 方式A: 精确匹配 next-number-picker 内的 input
						let pickerInput = node.querySelector('.next-number-picker-input input, [class*="number-picker"] input, [class*="NumberPicker"] input');
						if (pickerInput) {
							let val = parseInt(pickerInput.getAttribute('value') || pickerInput.getAttribute('aria-valuenow') || pickerInput.value);
							if (!isNaN(val) && val > 0) { apply_quantity = val; qtyFound = true; }
						}
						// 方式B: aria-valuenow 在 number-picker 容器上
						if (!qtyFound) {
							let pickerEl = node.querySelector('[aria-valuenow], .next-number-picker');
							if (pickerEl) {
								let ariaVal = pickerEl.getAttribute('aria-valuenow');
								if (ariaVal) {
									let val = parseInt(ariaVal);
									if (!isNaN(val) && val > 0) { apply_quantity = val; qtyFound = true; }
								}
								// 如果没有 aria，尝试读取 picker 内显示的文本数字
								if (!qtyFound) {
									let displayedText = pickerEl.textContent.replace(/[^\d]/g, '').trim();
									if (displayedText) {
										let val = parseInt(displayedText);
										if (!isNaN(val) && val > 0 && val < 100000) { apply_quantity = val; qtyFound = true; }
									}
								}
							}
						}
						// 方式C: 通用 input 兜底
						if (!qtyFound) {
							let inputEl = node.querySelector('input:not([type="checkbox"]):not([type="hidden"])');
							if (inputEl) {
								let val = parseInt(inputEl.getAttribute('value') || inputEl.value);
								if (!isNaN(val) && val > 0) { apply_quantity = val; qtyFound = true; }
							}
						}
						// 方式D: 通过 td 列中的纯数字文本匹配 (数量列通常紧跟在规格列之后)
						if (!qtyFound) {
							let tds = Array.from(node.querySelectorAll('td'));
							for (let t = 1; t < tds.length; t++) {
								let tdText = tds[t].textContent.trim();
								// 数量列通常只有纯数字，且数值较小 (1~9999)
								if (/^\d+$/.test(tdText)) {
									let val = parseInt(tdText);
									if (val > 0 && val < 10000) { apply_quantity = val; qtyFound = true; break; }
								}
							}
						}

						// 2. 价格
						let rebatePriceEl = node.querySelector(".item--colRebatePrice--s5tKrMS, [class*='item--colRebatePrice--'], .item--rebatePrice--KX1m_fR, [class*='item--rebatePrice--']");
						if (rebatePriceEl) {
							let text = rebatePriceEl.textContent;
							let cleanText = text.split('≈')[0].trim();
							let match = cleanText.match(/\d+(?:\.\d+)?/);
							if (match) price = parseFloat(match[0]).toFixed(2);
						} else {
							let pubPriceEl = node.querySelector(".item--colPublishPrice--_Gft88l, [class*='item--colPublishPrice--'], .item--publishPrice--ds7q4ew, [class*='item--publishPrice--']");
							if (pubPriceEl) {
								let match = pubPriceEl.textContent.match(/\d+(?:\.\d+)?/);
								if (match) price = parseFloat(match[0]).toFixed(2);
							}
						}

						// 价格兜底 1: 优先从小计（Subtotal）与数量来计算价格 (针对多规格单元格合并的情形)
						if (price === "0.00" || price === "0") {
							let subtotalEl = node.querySelector("[class*='Subtotal'], [class*='subtotal']");
							if (subtotalEl) {
								let match = subtotalEl.textContent.match(/\d+(?:\.\d+)?/);
								if (match) {
									let subtotal = parseFloat(match[0]);
									price = (subtotal / apply_quantity).toFixed(2);
								}
							}
						}

						// 价格兜底 2: 尝试根据 td 列的位置进行匹配 (需避开第0列规格列，以防将规格中的重量等数字误判为价格)
						if (price === "0.00" || price === "0") {
							let tds = Array.from(node.querySelectorAll('td'));
							if (tds.length >= 3) {
								// 倒数第二列是优惠价 (必须大于第0列的规格列)
								let rebateIdx = tds.length - 2;
								if (rebateIdx > 0) {
									let rebateTd = tds[rebateIdx];
									let text = rebateTd.textContent.split('≈')[0].trim();
									let match = text.match(/\d+(?:\.\d+)?/);
									if (match) {
										price = parseFloat(match[0]).toFixed(2);
									}
								}
								// 倒数第三列是原售价 (必须大于第0列的规格列)
								if (price === "0.00" || price === "0") {
									let pubIdx = tds.length - 3;
									if (pubIdx > 0) {
										let pubTd = tds[pubIdx];
										let matchPub = pubTd.textContent.trim().match(/\d+(?:\.\d+)?/);
										if (matchPub) price = parseFloat(matchPub[0]).toFixed(2);
									}
								}
							}
						}

						// 价格兜底 3: 如果还是 0.00 且存在同一个商品组 (tbody/table)，则使用同一组中已解析到的价格
						let parentGroup = node.closest('tbody') || node.closest('table') || node.parentElement;
						if (price !== "0.00" && price !== "0") {
							if (parentGroup) groupPriceMap.set(parentGroup, price);
						} else {
							if (parentGroup && groupPriceMap.has(parentGroup)) {
								price = groupPriceMap.get(parentGroup);
							}
						}

						// 3. 商品名称
						let tbody = node.closest('tbody');
						if (tbody) {
							let titleEl = tbody.querySelector(".item-group--title--F09mZrH, [class*='item-group--title--']");
							if (titleEl) goodsName = titleEl.textContent.trim();
						}
						if (!goodsName) {
							let table = node.closest('table');
							if (table) {
								let titleEl = table.querySelector("[class*='item-group--title--']");
								if (titleEl) goodsName = titleEl.textContent.trim();
							}
						}

						// 4. URL
						if (tbody) {
							let titleEl = tbody.querySelector(".item-group--title--F09mZrH, [class*='item-group--title--']");
							if (titleEl && titleEl.getAttribute('href')) {
								url = titleEl.getAttribute('href');
								if (url.startsWith('//')) url = 'https:' + url;
							}
						}

						// 5. 图片
						let skuImg = node.querySelector(".item--image--UO57i0S img, [class*='item--image--'] img, img");
						if (skuImg) {
							let src = skuImg.getAttribute('src') || skuImg.getAttribute('data-src');
							if (src) {
								if (src.startsWith('//')) src = 'https:' + src;
								imageUrl = src.replace(/_\d+x\d+\.jpg_\.webp/g, '').replace(/_\d+x\d+q90\.jpg/g, '');
							}
						}
						if (!imageUrl && tbody) {
							let mainImg = tbody.querySelector(".item-group--imageWrapper--gzJGxq1 img, [class*='item-group--image--'] img");
							if (mainImg) {
								let src = mainImg.getAttribute('src') || mainImg.getAttribute('data-src');
								if (src) {
									if (src.startsWith('//')) src = 'https:' + src;
									imageUrl = src.replace(/_\d+x\d+\.jpg_\.webp/g, '').replace(/_\d+x\d+q90\.jpg/g, '');
								}
							}
						}

						// 6. SKU规格
						let skuTitle = node.querySelector(".item--titleText--b4wDsV_, [class*='item--titleText--']");
						if (skuTitle) {
							color = skuTitle.textContent.trim();
						}

					} else {
						// === 淘宝/其他平台 解析逻辑 ===
						// 1. 价格
						let priceLabel = node.querySelector('.trade-price-container');
						if (priceLabel) {
							let containers = Array.from(node.querySelectorAll('.trade-price-container'));
							let promoContainer = containers.find(c => c.textContent.includes('店铺优惠后') || c.textContent.includes('优惠后'));
							let targetContainer = promoContainer || containers[0];
							
							let integer = targetContainer.querySelector('.trade-price-integer, .price-integer');
							let decimal = targetContainer.querySelector('.trade-price-decimal, .price-decimal');
							if (integer) {
								price = parseFloat(integer.textContent.trim() + (decimal ? '.' + decimal.textContent.trim() : '.00')).toFixed(2);
							} else {
								let match = targetContainer.textContent.match(/[¥￥]\s*(\d+(?:\.\d+)?)/);
								if (match) price = parseFloat(match[1]).toFixed(2);
							}
						} else {
							let textContent = node.textContent;
							let matches = Array.from(textContent.matchAll(/[¥￥]\s*(\d+(?:\s*\.\s*\d+)?)/g));
							if (matches.length > 0) {
								let numbers = matches.map(m => parseFloat(m[1].replace(/\s+/g, '')));
								let minPrice = Math.min(...numbers);
								price = minPrice.toFixed(2);
							}
						}

						// 2. 商品名称
						let aTags = Array.from(node.querySelectorAll('a')).filter(a => {
							const title = a.getAttribute('title') || '';
							const txt = a.textContent.trim();
							return (title.length > 8 || txt.length > 8) && !txt.includes('店铺') && !txt.includes('旗舰店');
						});
						if (aTags.length > 0) {
							goodsName = aTags[0].getAttribute('title') || aTags[0].textContent.trim();
						} else {
							let titleEl = node.querySelector('[class*="title"], [class*="name"]');
							if (titleEl) goodsName = titleEl.textContent.trim();
						}
						if (!goodsName) {
							const texts = Array.from(node.querySelectorAll('div, span, p')).map(e => e.textContent.trim());
							const longest = texts.sort((a, b) => b.length - a.length).find(t => t.length > 10 && !t.includes('¥') && !t.includes('￥') && !t.includes('优惠') && !t.includes('信用卡'));
							goodsName = longest || '';
						}

						// 3. 图片
						let imgs = Array.from(node.querySelectorAll('img'));
						if (imgs.length > 0) {
							let src = imgs[0].getAttribute('src') || imgs[0].getAttribute('data-src');
							if (src) {
								if (src.startsWith('//')) src = 'https:' + src;
								imageUrl = src.replace(/_\d+x\d+\.jpg_\.webp/g, '').replace(/_\d+x\d+q90\.jpg/g, '');
							}
						}
						if (!imageUrl) {
							let bgEls = Array.from(node.querySelectorAll('*')).filter(el => el.getAttribute('style') && el.getAttribute('style').includes('background-image'));
							if (bgEls.length > 0) {
								let match = bgEls[0].getAttribute('style').match(/url\(["']?(.*?)["']?\)/);
								if (match && match[1]) {
									let src = match[1];
									if (src.startsWith('//')) src = 'https:' + src;
									imageUrl = src.replace(/_\d+x\d+\.jpg_\.webp/g, '').replace(/_\d+x\d+q90\.jpg/g, '');
								}
							}
						}

						// 4. 数量
						let inputEl = node.querySelector('input:not([type="checkbox"]):not([type="hidden"])');
						if (inputEl) {
							let val = parseInt(inputEl.getAttribute('value') || inputEl.value);
							if (!isNaN(val)) apply_quantity = val;
						} else {
							const text = node.textContent;
							const match = text.match(/(?:数量|x|X|✖|\*)\s*(\d+)/);
							if (match) apply_quantity = parseInt(match[1]);
						}

						// 5. SKU规格
						let skuContainer = node.querySelector('.trade-cart-item-sku-old, [class*="sku--"], .sku-info, .spec-info');
						const noiseRegex = /理由|退换|退货|极速|退款|保|赠品|快照|假一赔|服务|分期|保险|赠送/;
						if (skuContainer) {
							const labels = Array.from(skuContainer.querySelectorAll('.label--T4deixnF, div, span, p'))
								.map(el => el.textContent.trim())
								.filter(txt => txt && !noiseRegex.test(txt));
							
							labels.forEach(txt => {
								if (txt.includes('尺寸') || txt.includes('尺码')) {
									size = txt.replace(/^(尺寸|尺码)[:：]?\s*/, '').trim();
								} else if (txt.includes('颜色')) {
									color = txt.replace(/^(颜色分类|颜色)[:：]?\s*/, '').trim();
								} else {
									if (!size && txt.length > 0) size = txt;
									else if (!color && txt.length > 0) color = txt;
								}
							});
						} else {
							const text = node.innerText || node.textContent || '';
							let colorMatch = text.match(/(?:颜色分类|颜色)[:：]\s*([^;；\n\t]+)/);
							if (colorMatch) color = colorMatch[1].trim();
							let sizeMatch = text.match(/(?:尺寸|尺码)[:：]\s*([^;；\n\t]+)/);
							if (sizeMatch) size = sizeMatch[1].trim();
						}

						// 6. URL
						let aLink = node.querySelector('a[href*="item.taobao.com"], a[href*="detail.1688.com"]');
						if (aLink) {
							url = aLink.getAttribute('href');
							if (url.startsWith('//')) url = 'https:' + url;
						} else {
							let anyLink = node.querySelector('a[href*="id="]');
							if (anyLink) {
								url = anyLink.getAttribute('href');
								if (url.startsWith('//')) url = 'https:' + url;
							}
						}
					}

					// 7. 订单号 (通用)
					let order_no = "";
					const text = node.textContent;
					const orderMatch = text.match(/(?:订单号|订单编号|주문번호)[:：]?\s*(\d{15,25})/);
					if (orderMatch) order_no = orderMatch[1];

					items.push({
						id: this.generateId(),
						order_no: order_no,
						goods_name: goodsName,
						price: price,
						apply_quantity: apply_quantity,
						size: size,
						color: color,
						url: url,
						goods_image: imageUrl,
						imageUrl: imageUrl,
						category_id:'',
						category_name:'',
						hs_code: '',
						tracking_no:'',
						product_code:'',
						box_count: undefined,
						refer_code:'',
						shipping_memo:'',
						// origin: false,
						// package:false,
						// check:false,
						showPopover: false,
						show_extra_services: false,
						remove: [],
						check_level: '',
						packing_level: '',
						add_packing: [],
						template: [],
						template15_cnt: 1,
						template16_cnt: 1,
						template17_cnt: 1,
						template18_cnt: 1,
						template19_cnt: 1,
						template20_cnt: 1,
						template21_cnt: 1,
						customs: [],
					});
				}

				if (items.length > 0) {
					// 替换或添加进表单
					// 如果第一个元素是空行，先删除
					if (this.formData.items.length === 1 && !this.formData.items[0].goods_name) {
						this.formData.items = items;
					} else {
						this.formData.items = [...this.formData.items, ...items];
					}
					this.$message.success(`${items.length}개의 상품을 성공적으로 가져왔습니다.`);
					this.onCloseImport();
				} else {
					this.$message.error("파싱된 상품이 없습니다. 올바른 영역을 복사했는지 확인해주세요.");
				}
			},
			extractColor(doc, i) {
				let itemNodes = doc.querySelectorAll(".order-list-content order-item .order-item-entry-container .order-item-entry");
				if (itemNodes.length === 0) itemNodes = doc.querySelectorAll(".order-item-entry");
				const node = itemNodes[i];
				if (!node) return '';
				
				const noiseRegex = /理由|退换|退货|极速|退款|保|赠品|快照|假一赔|服务|分期|保险|赠送/;
				const specEls = Array.from(node.querySelectorAll('.sku-info-item, .product-prop, .spec-info, .spec-item'))
					.map(el => el.textContent.trim())
					.filter(txt => txt && !noiseRegex.test(txt));
				
				let color = "";
				if (specEls.length > 0) {
					// 0. 特殊处理：分号分隔 (尺寸;颜色)
					const semiPair = specEls.find(txt => (txt.includes(';') || txt.includes('；')) && !/[:：]/.test(txt));
					if (semiPair) {
						const parts = semiPair.split(/[;；]/).map(p => p.trim());
						if (parts.length >= 2) color = parts[1];
					}

					if (!color) {
						const idx = specEls.findIndex(txt => /颜色[:：]/.test(txt));
						if (idx !== -1) {
							color = specEls[idx].replace(/颜色[:：]\s*/, '').trim();
						} else {
							// 没有分号默认填尺寸
							if (specEls.length > 1) color = specEls[0];
							else color = "";
						}
					}
				}
				
				if (!color) {
					const text = node.innerText || '';
					const match = text.match(/颜色[:：]\s*([^;；\n\t]+)/);
					color = match ? match[1].trim() : '';
				}
				return color;
			},
			extractSize(doc, i) {
				let itemNodes = doc.querySelectorAll(".order-list-content order-item .order-item-entry-container .order-item-entry");
				if (itemNodes.length === 0) itemNodes = doc.querySelectorAll(".order-item-entry");
				const node = itemNodes[i];
				if (!node) return '';
				
				const noiseRegex = /理由|退换|退货|极速|退款|保|赠品|快照|假一赔|服务|分期|保险|赠送/;
				const specEls = Array.from(node.querySelectorAll('.sku-info-item, .product-prop, .spec-info, .spec-item'))
					.map(el => el.textContent.trim())
					.filter(txt => txt && !noiseRegex.test(txt));
				
				let size = "";
				if (specEls.length > 0) {
					// 0. 特殊处理：分号分隔 (尺寸;颜色)
					const semiPair = specEls.find(txt => (txt.includes(';') || txt.includes('；')) && !/[:：]/.test(txt));
					if (semiPair) {
						const parts = semiPair.split(/[;；]/).map(p => p.trim());
						if (parts.length >= 2) size = parts[0];
					}

					if (!size) {
						const idx = specEls.findIndex(txt => /尺码[:：]/.test(txt));
						if (idx !== -1) {
							size = specEls[idx].replace(/尺码[:：]\s*/, '').trim();
						} else {
							// 没有分号默认填尺寸
							if (specEls.length === 1) size = specEls[0];
							else if (specEls.length > 1) {
								const colorIdx = specEls.findIndex(txt => /颜色[:：]/.test(txt));
								if ((colorIdx === 0 || colorIdx === -1)) size = specEls[1];
							}
						}
					}
				}
				
				if (!size) {
					const text = node.innerText || '';
					const match = text.match(/尺码[:：]\s*([^;；\n\t]+)/);
					size = match ? match[1].trim() : '';
				}
				return size;
			},
			onUpload(index){
				this.imageIndex = index
				this.uploadVisible = true
			},
			changeUpload(val){
				this.imageUrl = ""
				this.upload = val
			},
			handleAvatarSuccess(res, file) {
				this.imageUrl = res.data.url;
				// 直接上传选项时，成功后自动提交并关闭弹框
				if (this.upload == 1) {
					this.submitUpload();
				}
			},
			/**
			 * 关闭图片上传弹窗时的回调
			 * @description 清除预览图链接，确保下次打开是空白状态
			 */
			onCloseUpload(){
				this.imageUrl = ""
			},
			beforeAvatarUpload(file) {
			    const isLt2M = file.size / 1024 / 1024 < 20;
			    if (!isLt2M) {
			      this.$message.error('업로드 사진 크기는 20MB를 초과할 수 없습니다!');
			    }
			    return  isLt2M;
			},
			submitUpload(){
				console.log(this.imageUrl,"이미지")
				this.formData.items[this.imageIndex].imageUrl = this.imageUrl
				this.formData.items[this.imageIndex].goods_image = this.imageUrl
				this.uploadVisible = false
				this.imageUrl = ""
			},
			onNewNav(url) {
				window.open(url, '_blank');
			},
			onCargoType(value){
				console.log(value,"22222222")
				if(value == 1){//预付
					alert("팀머니 100,000원 이상이어야 신청 가능합니다.");
					this.formData.data.service_cargo_type = '2'
				}
			},
			formatImgUrl(url) {
				if (!url) return '';
				if (url.startsWith('http') || url.startsWith('//') || url.startsWith('data:')) {
					return url;
				}
				const apiBase = Constants.BASE_URL || '';
				const domain = apiBase.replace(/\/api\/?$/, '');
				return domain + (url.startsWith('/') ? '' : '/') + url;
			},
			onReturn(){
				safePush(this.$router, '/agencyShipping');
			},
			getAgencyAttach(){
				console.log("附加服务申请历史记录")
				return request.post('/member/Agency/getAgencyAttach',{}
				).then(res => {
					console.log(res,"记录1")
					if(res.code ==1){
						 this.agency_attach = res.data
					}		
				});
			},
			loadAgencyDetail(id) {
				request.post('/member/Agency/getAgencyDetailForEdit', { id }).then(res => {
					if (res.code === 1) {
						const data = res.data;
						this.deliveryCenterCode = data.delivery_center_code;
						this.customsType = data.customs_type;
						if (this.customsType == 2) {
							this.customsTypeName = '목록통관';
						} else if (this.customsType == 1) {
							this.customsTypeName = '간이통관';
						} else if (this.customsType == 3) {
							this.customsTypeName = '사업자통관';
						}
						
						if (this.deliveryCenterCode === 'CN_AIR') {
							this.AirVisible = true;
						}

						// Pre-fill main form attributes
						this.formData.data.remove = data.remove || [];
						this.formData.data.check_level = data.check_level ? Number(data.check_level) : '';
						this.formData.data.packing_level = data.packing_level ? Number(data.packing_level) : '';
						this.formData.data.add_packing = data.add_packing || [];
						this.formData.data.template = data.template || [];
						
						// Pre-fill template counters
						if (this.agency_attach && this.agency_attach.template) {
							this.agency_attach.template.forEach(t => {
								const cntKey = `template${t.id}_cnt`;
								this.$set(this.formData.data, cntKey, data[cntKey] !== undefined ? Number(data[cntKey]) : 1);
							});
						}
						
						this.formData.data.customs = data.customs || [];
						this.formData.data.address_id = data.address_id;
						this.formData.data.express_demand = data.express_demand || '';
						this.formData.data.pay_service = data.pay_service || [];
						this.formData.data.service_cargo_type = String(data.service_cargo_type || '2');
						this.formData.data.service_fta_type = String(data.service_fta_type || '2');
						this.formData.data.service_tariff_notify = String(data.service_tariff_notify || '2');
						this.formData.data.is_agree = true; // Set to true by default for editing

						// Pre-fill address info
						this.address_info = data.address_info || {};

						// Pre-fill goods items
						this.formData.items = (data.goods || []).map(goods => {
							const item = {
								id: goods.id,
								goods_id: goods.id,
								category_id: goods.category_id,
								category_name: goods.category_name,
								hs_code: goods.hs_code || '',
								goods_name: goods.goods_name,
								tracking_no: goods.tracking_no || '',
								size: goods.size || '',
								order_no: goods.order_no || '',
								color: goods.color || '',
								price: String(goods.price || ''),
								product_code: goods.product_code || '',
								box_count: goods.box_count !== undefined ? Number(goods.box_count) : '',
								apply_quantity: goods.apply_quantity !== undefined ? Number(goods.apply_quantity) : 1,
								refer_code: goods.refer_code || '',
								url: goods.url || '',
								shipping_memo: goods.shipping_memo || '',
								// origin: goods.origin == 1,
								// package: goods.package == 1,
								// check: goods.check == 1,
								goods_image: goods.goods_image || '',
								imageUrl: goods.imageUrl || goods.goods_image || '',
								showPopover: false,
								show_extra_services: false,
								remove: goods.remove || [],
								check_level: goods.check_level !== undefined && goods.check_level !== null ? Number(goods.check_level) : '',
								packing_level: goods.packing_level !== undefined && goods.packing_level !== null ? Number(goods.packing_level) : '',
								add_packing: goods.add_packing || [],
								template: goods.template || [],
								customs: goods.customs || []
							};
							
							// Set item level template counts
							if (this.agency_attach && this.agency_attach.template) {
								this.agency_attach.template.forEach(t => {
									const cntKey = `template${t.id}_cnt`;
									this.$set(item, cntKey, goods[cntKey] !== undefined ? Number(goods[cntKey]) : 1);
								});
							}
							return item;
						});

						this.show = true;
					} else {
						this.$message.error(res.msg || '정보를 불러오지 못했습니다.');
						this.show = false;
					}
				}).catch(err => {
					console.error(err);
					this.$message.error('서버와의 통신 오류가 발생했습니다.');
					this.show = false;
				});
			},
			onCheck(value){
				console.log(value)
			},
			openAddress(){
				this.addressVisible = true
				this.getAddressList()
			},
			selAddress(row){
				//选择地址
				console.log(row,"选择地址")
				this.address_info = row
				this.formData.data.address_id = row.id
				this.addressVisible = false
			},
			getAddressList(){
				request.post('/member/Address/addressList',{}
				).then(res => {
					console.log(res,"列表")
					if(res.code ==1){
						this.address_total = res.data.length
						this.addressData= res.data
					}		
				});
			},
			// calcAmount(){
			// 	console.log(this.sales_tax)
			// 	let sum = this.sales_tax +this.shipping-this.discount
			// 	console.log(sum,"计算金额")
			// 	alert("기대해주세요.")
			// },
			onCurrentNav(url){
				this.$router.push(url);	
			},
			onSearch(){
				console.log(this.search)
				this.getCategoryList()
			},
			getCategoryList(){
				request.post('/member/Agency/getCategoryList',{
					search:this.search
				})
				.then(res => {
					console.log(res,"212")
					if(res.code ==1){
						this.category_list = res.data
					}
						
				});
				
			},
			onCategoryDialog(index){
				this.category_index = index
				this.CategoryVisible = true
				if (this.flattenedCategories.length === 0) {
					this.processCategories()
				}
			},
			processCategories() {
				const result = []
				let counter = 0
				categoryData.categories.forEach((cat) => {
					cat.items.forEach((item) => {
						if (item.hscode_10_details && item.hscode_10_details.length > 0) {
							item.hscode_10_details.forEach((h10) => {
								result.push({
									uniqueId: counter++,
									item_id: item.id,
									l1: cat.category_name,
									l2: item.name_ko,
									l2_code: item.hs_code,
									l2_cn: item.name_cn,
									l2_en: item.name_en,
									l3: h10.hscode_10_name,
									l3_code: h10.hscode_10
								})
							})
						} else {
							result.push({
								uniqueId: counter++,
								item_id: item.id,
								l1: cat.category_name,
								l2: item.name_ko,
								l2_code: item.hs_code,
								l2_cn: item.name_cn,
								l2_en: item.name_en,
								l3: '-',
								l3_code: '-'
							})
						}
					})
				})
				this.flattenedCategories = Object.freeze(result)
			},
			highlightCategoryText(text) {
				if (!this.categorySearch || text === undefined || text === null || text === '-') return text
				const str = String(text)
				const query = this.categorySearch.trim().toLowerCase()
				if (!query) return str
				const regex = new RegExp(query.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'gi')
				return str.replace(regex, match => `<span class="hl-text-category">${match}</span>`)
			},
			handleSelectCategory(row) {
				console.log("选择分类:", row)
				if (this.category_index !== '') {
					const item = this.formData.items[this.category_index];
					item.category_name = row.l2;
					item.goods_name = row.l2_en;
					item.hs_code = (row.l3_code && row.l3_code !== '-') ? row.l3_code : row.l2_code;
					item.category_id = row.item_id;
					item.showPopover = false;
				}
			},
			onSearchInput(index) {
				this.categorySearch = this.formData.items[index].category_name
				this.formData.items[index].showPopover = true
				this.category_index = index
			},
			generateId() {
			  return Date.now() + '_' + Math.random().toString(36).substr(2, 9)
			},
			
			/**
			 * 添加新的表单项
			 */
			addItem() {
			  this.formData.items.push({
				id: this.generateId(), // 唯一标识，用于key
				category_id:'',
				category_name:'',
				hs_code: '',
				goods_name: '',
				tracking_no:'',
				size:'',
				order_no:'',
				color:'',
				price:'',
				product_code:'',
				box_count: undefined,
				apply_quantity: undefined,
				refer_code:'',
				url:'',
				shipping_memo:'',
				// origin: false,
				// package:false,
				// check:false,
				goods_image:'',
				imageUrl:'',
				showPopover: false,
				show_extra_services: false,
				remove: [],
				check_level: '',
				packing_level: '',
				add_packing: [],
				template: [],
				template15_cnt: 1,
				template16_cnt: 1,
				template17_cnt: 1,
				template18_cnt: 1,
				template19_cnt: 1,
				template20_cnt: 1,
				template21_cnt: 1,
				customs: [],
			  })
			},
		
			/**
			 * 删除指定索引的表单项
			 * @param {Number} index - 要删除的表单项索引
			 */
			removeItem(index) {
			 //  this.$confirm('确定要删除这个表单项吗？', '提示', {
				// confirmButtonText: '确定',
				// cancelButtonText: '取消',
				// type: 'warning'
			 //  }).then(() => {
				this.formData.items.splice(index, 1)
				// this.$message.success('表单项已删除')
			 //  }).catch(() => {
				// // 取消删除
			 //  })
			},
			hasSelectedExtraServices(item) {
				return (
					(item.remove && item.remove.length > 0) ||
					(item.check_level !== '' && item.check_level !== null && item.check_level !== undefined) ||
					(item.packing_level !== '' && item.packing_level !== null && item.packing_level !== undefined) ||
					(item.add_packing && item.add_packing.length > 0) ||
					(item.template && item.template.length > 0) ||
					(item.customs && item.customs.length > 0)
				);
			},
			formatSelectedExtraServices(item) {
				if (!this.agency_attach) return '';
				const selected = [];
				
				const getName = (list, id) => {
					if (!list) return '';
					const found = list.find(x => x.id === id);
					return found ? found.name : '';
				};

				if (item.remove && item.remove.length > 0) {
					item.remove.forEach(id => {
						const name = getName(this.agency_attach.remove, id);
						if (name) selected.push(name);
					});
				}

				if (item.check_level !== '' && item.check_level !== null && item.check_level !== undefined) {
					const name = getName(this.agency_attach.check_level, item.check_level);
					if (name) selected.push(name);
				}

				if (item.packing_level !== '' && item.packing_level !== null && item.packing_level !== undefined) {
					const name = getName(this.agency_attach.packing_level, item.packing_level);
					if (name) selected.push(name);
				}

				if (item.add_packing && item.add_packing.length > 0) {
					item.add_packing.forEach(id => {
						const name = getName(this.agency_attach.add_packing, id);
						if (name) selected.push(name);
					});
				}

				if (item.template && item.template.length > 0) {
					item.template.forEach(id => {
						const name = getName(this.agency_attach.template, id);
						if (name) {
							const count = item[`template${id}_cnt`] || 1;
							selected.push(`${name}(${count}개)`);
						}
					});
				}

				if (item.customs && item.customs.length > 0) {
					item.customs.forEach(id => {
						const name = getName(this.agency_attach.customs, id);
						if (name) selected.push(name);
					});
				}

				return selected.join(', ');
			},
			openExtraServicesDialog(index) {
				this.currentExtraServiceItemIndex = index;
				this.extraServiceDialogVisible = true;
			},
			clearCurrentExtraItemServices() {
				if (this.currentExtraItem) {
					const item = this.currentExtraItem;
					item.remove = [];
					item.check_level = '';
					item.packing_level = '';
					item.add_packing = [];
					item.template = [];
					item.customs = [];
					if (this.agency_attach && this.agency_attach.template) {
						this.agency_attach.template.forEach(t => {
							this.$set(item, `template${t.id}_cnt`, 1);
						});
					}
					this.$message.success('선택한 부가서비스가 모두 초기화되었습니다.');
				}
			},
		
			/**
			 * 提交表单
			 */
			submitForm() {
				this.$refs.dynamicForm.validate((valid) => {
					if (valid) {
						this.formData.data.is_agree
						if(this.formData.data.is_agree){
							// 表单验证通过，准备提交数据
							const submitData = {
								items: [...this.formData.items]
							}
							console.log(submitData,"结果")
							console.log(this.formData.data,"结果2")
							console.log(this.totalAmount.toFixed(2),"结果2")
					
							
							if(!this.formData.data.address_id){
								alert("주소 필수")
								return
							}

							request.post('/member/Agency/editDgency',
								{
									"id": this.$route.query.id,
									"item":submitData,
									"data":this.formData.data,
									"total_amount":this.totalAmount.toFixed(2),
									//"agreement_yn":this.agreement_yn,
									"delivery_center_code":this.deliveryCenterCode,
									"customs_type":this.customsType,
									"agency_type":'2',//采购代理
								}
							).then(response => {
								console.log(response,"提交?????")			  
								if(response.code ==1){
									alert('Success！！！');
									//console.log('稍后审核！');
									this.$router.replace('/orderBundle');

								}else{
									alert(response.msg)
									return
								}
									
							});
							
							
							
							
						}else{
							alert("주의사항에 동의해야 등록이 가능합니다.")
						}
			  
					} else {
					  // 表单验证失败
					  this.$message.error('작성된 내용을 확인하십시오.')
					  return false
					}
				})
			},

		}
	}
</script>

<style scoped>
	.config-title-wrap {
	    display: flex;
		justify-content: space-between;
	    align-items: center;
	    margin-bottom: 60px;
		padding:0 50px;
	}
	.config-title-wrap h3 {
	    border: none;
	    padding-bottom: 0;
		font-size: 36px;
		font-weight: bold;
		padding: 0 0 24px 20px;
		/* border-bottom: 1px solid #bcbcbc; */
		position: relative;
		margin: 0 0 30px;
	}
	.config-title-wrap h3:before {
	    content: '';
	    display: block;
	    width: 10px;
	    height: 48px;
	    background: #ffd04b;
	    position: absolute;
	    left: 0;
	    top: -4px;
	}
	.config-title-wrap p {
	    color: #5a5a5a;
	    line-height: 30px;
	    margin: 0;
	}
	.config-title-wrap .get-order {
	    display: flex;
	    flex-direction: column;
	}
	.config-title-wrap .link-excel {
		margin-top: 10px;
	    font-weight: 600;
	    background-color: #fff;
	    color: #111;
	    text-decoration: none;
	    border: 1px solid var(--border-color);
	    border-radius: 44px;
	    display: flex;
	    align-items: center;
	    justify-content: center;
	    padding: 15px 0;
	    min-width: 337px;
	    width: 100%;
	}
	
	/* 分类弹框 */
	.agency-category-customs{
		display: flex;
	}
	.agency-category-customs .type-general{
		background-color: #0055d4;
		width: 18px;
		height: 18px;
		border-radius: 6px;
		margin: 0 5px 0 15px;
	}
	.agency-category-customs .type-list{
		background-color: #c33;
		width: 18px;
		height: 18px;
		border-radius: 6px;
		margin: 0 5px 0 15px;
	}
	.help-block{
	    background-color: #d5e6fa;
	    color: #274780;
	    display: flex;
	    min-height: 40px;
		padding:5px 0;
	    border-radius: 12px;
	    align-items: center;
	    padding-left: 19px;
	    margin: 17px 0 20px;
	}
	.agreement-box{
		border: 1px solid var(--border-color);
		padding: 15px;
		margin: 25px 0 5px;
		border-radius: 20px;
	}
	.height-fixed-box{

		height: 400px;
		overflow-y: scroll;
		padding-right: 20px;
		font-size: 12px;
		color: #333;
	}
	.height-fixed-box ol {
	    margin: 0;
	    padding: 0;
	}
	.height-fixed-box .depth1 {
	    border: 1px solid #e5e5e5;
	    border-radius: 13px;
	    margin-bottom: 20px;
	}
	.height-fixed-box li {
	    margin: 0 0 30px 0;
	    padding: 0;
	    list-style: none;
	}
	.height-fixed-box li li {
	    display: inline-flex;
	    align-items: center;
	    margin: 0;
	    padding: 3px 5px;
	    width: 30%;
	    font-size: 13px;
	}
	.height-fixed-box li strong.namecolor-blue {
	    background-color: #0055d4;
	    border-top-left-radius: 8px;
	    border-top-right-radius: 8px;
	    padding: 9px 25px 6px;
	    font-size: 15px;
	    margin-bottom: 0;
	}
	.height-fixed-box li strong {
	    display: block;
	    background: #666;
	    color: #fff;
	    font-weight: 500;
	}
	.height-fixed-box .name{
		cursor: pointer;
	}
	.air-popup-content{
		padding: 0 10px;
	}
	.air-popup-content h2 {
		color:var(--navy-color);
	    font-size: 36px;
	    font-weight: bold;
	    text-align: center;
	    margin-top: 54px;
	    margin-bottom: 70px;
	}
	.air-popup-content .category-title{
		color: var(--main-color);
		font-size: 20px;
		font-weight: bold;
	}
	ul.dot-list {
	    margin: 0;
	    padding: 0;
	    list-style: none;
		margin-top: 16px;
		margin-bottom: 20px;
		padding-left: 7px;
	}
	ul.dot-list li {
	    color: #333;
	    font-size: 16px;
	    line-height: 28px;
		font-weight: 600;
	}
	ul.dot-list li a{
		font-weight: bold;
		text-decoration: none;
		color: #337ab7;
	}

	.air-popup-content strong {
		color: #fe561d;
		text-align: center;
		display: block;
		font-size: 18px;
		margin-top: 49px;
	}
	.link-btn{
		margin-top: 10px;
		display: inline-flex;
		justify-content: center;
		align-items: center;
		border-radius: 19px;
		font-weight: 600;
		font-size: 12px;
		text-transform: uppercase;
		text-decoration: none !important;
		border: 1px solid var(--main-color);
		padding: 7px 17px;
		width:180px;
		transition: 0.25s;
		line-height: normal;
		cursor: pointer;
	}
	.link-btn.type-2{
		color: var(--main-color);
		background: #fff;
	}
	.air-popup-content p.popup-desc {
		padding-top: 20px;
	    font-size: 14px;
	    font-weight: 500;
	}
	.customs-real-price {
	    display: flex;
	    gap: 20px;
	    justify-content: space-between;
	    margin-bottom: 60px;
	    flex-wrap: wrap;
	}
	.customs-real-price .box {
	    flex: 1;
	    background: #fff;
	    border: 1px solid var(--border-color);
	    border-radius: var(--border-radius);
	    padding: 20px;
	}
	.customs-real-price .box .title {
	    font-weight: bold;
	    margin-bottom: 30px;
		text-align: center;
	}
	.input-group {
	    position: relative;
	    display: flex;
		align-items: center;
	    border-collapse: separate;
	}
	.customs-real-price .box .input-group-addon{
		padding-left: 10px;
	}
	.customs-real-price .box.total .title {
	    height: 44px;
	    line-height: 44px;
	    border-bottom: 1px solid var(--border-color);
	    margin: 0;
	    text-align: center;
	}
	.customs-real-price .explain {
	    flex: 0 0 100%;
	    text-align: right;
	    line-height: 160%;
	    margin: 0;
	}
	.customs-after-box {
	    display: flex;
	    justify-content: space-between;
	    align-items: center;
	    background: #fff;
	    border: 1px solid var(--border-color);
	    border-radius: var(--border-radius);
	    height: 147px;
	    padding: 40px;
	    margin-bottom: 30px;
		color:var(--background-color);
	}
	.customs-after-box .customs strong {
	    font-size: 36px;
	    vertical-align: middle
	}
	.customs-after-box .customs a {
	    border-radius: 12px;
	    text-decoration: none;
	    font-size: 17px;
	    width: 140px;
	    height: 55px;
	    line-height: 55px;
	    margin-left: 20px;
	    padding: 0;
	}
	.btn {
	    display: inline-block;
	    margin-bottom: 0;
	    font-weight: 400;
	    text-align: center;
	    white-space: nowrap;
	    vertical-align: middle;
	    touch-action: manipulation;
	    cursor: pointer;
	    background-image: none;
	    border: 1px solid transparent;
	}
	.btn-submit, .btn-submit:focus {
	    background-color: var(--main-color);
	    border-color: var(--main-color);
	    color: #fff !important;
	}
	.customs-after-box .after {
	    text-align: right;
	}
	.customs-after-box .after .total-price {
	    font-size: 24px;
	    font-weight: bold;
	}
	.customs-after-box .after .total-price span {
	    color: var(--main-color);
	}
	.type-card {
	    margin-bottom: 50px;
	    overflow: visible;
	}
	.type-card.shadow-all {
	    border: none;
		border-radius: 26px;
	    box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.1);
	}
	.type-card .card-head {
	    height: 77px;
	    text-align: left;
	    justify-content: left;
	    font-size: 24px;
	    padding-left: 40px;
	    font-weight: bold;
	    border-top-left-radius: 26px;
	    border-top-right-radius: 26px;
	}
	.type-card > .card-head {
	    line-height: normal;
	    display: flex;
	    align-items: center;
	    color: #fff;
	    gap: 0 8px;
	    background: rgb(247, 148, 29);
	}
	.type-card .card-body {
	    padding: 35px 39px;
	    border-bottom-left-radius: 26px;
	    border-bottom-right-radius: 26px;
		background: var(--frontground-color);
	}
	.link-btn.type-1 {
	    color: #fff;
	    background: var(--main-color);
	}
	.type-card .card-help {
	    font-size: 17px;
	    font-weight: 600;
	    color: var(--navy-color);
	    background: #f4f8ff;
	    padding: 12px 20px;
	    margin-bottom: 30px;
	}
	.checkbox-inline{
		display: flex;
		align-items: center;
		border: 1px solid var(--border-color);
		border-radius: 14px;
		padding: 13px 10px !important;
		font-size: 15px;
		font-weight: bold;
/* 		width: 100%; */
		height: 50px;
		background-color: #fff;
		margin: 15px 20px 15px 0;
	}
	
	.checkbox-inline-margin{
		margin: 15px 30px 0 0
	}
	
	label.checkbox-inline > span {
	    margin-left: auto;
	    color: var(--main-color);
	    font-size: 14px;
	    font-weight: 500;
	}
	.col-wrap h4{
		font-size: 20px;
		font-weight: bold;
		/* margin: 0 0 15px; */
		color: var(--background-color);
	}
	.col-wrap .group{
		margin-bottom: 30px;
	}
	.card-help .normal {
	    font-weight: normal;
	    display: block;
	    font-size: 16px;
	}
	.caution-box {
	    border-radius: var(--border-radius);
	    /* background: #f5f6fb; */
	    margin-bottom: 30px;
		padding:20px;
		line-height: 30px;
		font-size: 14px;
	}
	.caution-agree {
	    border: 1px solid var(--border-color);
	    text-align: center;
	    padding: 20px 0 21px;
	    margin-bottom: 30px;
	}


	
	.icon-question{
		color:var(--main-color);padding-left: 5px;font-size: 18px;
	}
	.flex{
		display: flex;
	}
	.color-blue {
	    color: #0055d4 !important;
	}
	.color-red {
	    color: #cc3333 !important;
	}
	.text-center {
	    text-align: center !important;
	}
	
	/* 分类虚拟下拉样式 */
	.category-popper {
		max-width: 100vw;
		padding: 0 !important;
	}
	.category-dropdown-content {
		padding: 15px;
		background: #fff;
	}
	.category-dropdown-content .search-box {
		margin-bottom: 12px;
	}
	.scroller-container {
		border: 1px solid #eee;
		border-radius: 8px;
		overflow: hidden;
		display: flex;
		flex-direction: column;
		height: 400px;
	}
	.v-table-header {
		display: flex;
		background-color: #f0f7ff;
		height: 40px;
		align-items: center;
		padding: 0 15px;
		font-weight: bold;
		color: #0055d4;
		font-size: 13px;
		border-bottom: 1px solid #d0e3f7;
	}
	.category-v-scroller {
		flex: 1;
	}
	.v-category-row {
		display: flex;
		align-items: center;
		padding: 0 15px;
		height: 65px;
		border-bottom: 1px solid #f5f5f5;
		box-sizing: border-box;
	}
	.v-category-row:hover {
		background-color: #fafafa;
	}
	.v-col-l1 { width: 120px; flex-shrink: 0; color: #0055d4; font-weight: bold; font-size: 13px; }
	.v-col-l2 { width: 220px; flex-shrink: 0; padding: 0 10px; display: flex; flex-direction: column; justify-content: center; }
	.v-col-l3 { flex: 1; min-width: 0; padding-left: 10px; display: flex; flex-direction: column; justify-content: center; }
	
	.v-category-row .ko { font-size: 13px; color: #333; margin-bottom: 2px; }
	.v-category-row .cn { font-size: 11px; color: #e67e22; font-weight: 500; }
	.v-category-row .code { color: #999; font-family: monospace; font-size: 11px; }

	::v-deep .hl-text-category {
		background-color: #fffb8f;
		color: #f5222d;
		font-weight: bold;
		padding: 0 2px;
		border-radius: 2px;
	}
	.font-popover{
		font-size: 12px;font-weight: 400;
	}
	.el-table::before {
	    background-color: rgba(255,255,255,0) ;
	}
	.background-color{
		color:var(--background-color);
	}
	.frontground-color{
		color: var(--frontground-color);
	}
	@media (min-width: 992px) {
		.content-zsy{
			width: 1270px;
			margin: 2.5rem auto;
		}
	}
	@media (max-width: 768px) {
		.content-zsy{
			padding:40px 10px;
		}
		.config-title-wrap{
			padding:0 10px;
		}
		.config-title-wrap h3 {
		    font-size: 24px;
		    font-weight: bold;
		    padding: 0 0 14px 12px;
		    position: relative;
		    margin: 0 0 20px;
		}
		.config-title-wrap h3:before {	
		    width: 4px;
		    height: 21px;
		    top: 6px;
		}
		.air-popup-content h2 {
			font-size: 24px;
			margin-top: 14px;
			margin-bottom: 30px;
		}
		.air-popup-content strong {
			display: block;
			font-size: 16px;
			margin-top: 10px;
		}
		.customs-real-price {
		    gap: 15px;
		}
		.customs-real-price .box{
			padding: 10px;
		}
		.customs-real-price .box .title {
		    font-size: 14px;
		}
		.customs-after-box {
		    display: flex;
		    justify-content: space-between;
		    align-items: center;
		    background: #fff;
		    border: 1px solid var(--border-color);
		    border-radius: var(--border-radius);
		    padding: 20px;
		    margin-bottom: 40px;
		    flex-wrap: wrap;
		}
		.customs-after-box .customs {	
		    display: flex;
		    justify-content: space-between;
		    align-items: center;
		    width: 100%;
		    padding-bottom: 10px;
		    border-bottom: 1px solid var(--border-color);
		    margin-bottom: 10px;
		}
		.customs-after-box .customs a {
		    width: 75px;
		    height: 36px;
		    line-height: 36px;
		    background-color: var(--secondary-color) !important;
		}
		.customs-after-box .customs strong {
		    font-size: 18px;
		}
		.customs-after-box .after{
			text-align: right;
			 width: 100%;
		}
		.customs-after-box .after .total-price {
		    font-size: 18px;
		}
		.type-card .card-body {
		    padding: 20px;
		    background: #fff;
		}
		.type-card .card-help {
		    padding: 10px;
			font-size: 14px;
		    margin-bottom: 20px;
		    word-break: keep-all;
		    line-height: 160%;
		}
		

		
	}

	::v-deep .num-input-left .el-input__inner {
		text-align: left !important;
		padding-left: 15px;
	}

	.config-title-wrap .get-order .top {
	    display: flex;
	    gap: 10px;
	}
	.config-title-wrap .get-order ul {
	    list-style-type: none;
	    padding: 0;
	    display: flex;
	    flex-direction: column;
	    gap: 5px;
	}
	.config-title-wrap .get-order li {
	    background: #fff;
	    border: 1px solid var(--border-color);
	    border-radius: 10px;
	    color: rgba(0, 0, 0, 0.8);
	    font-weight: 500;
	    display: flex;
	    align-items: center;
	    justify-content: space-between;
	    padding: 0 14px;
	    width: 160px;
	    height: 46px;
	}
	.config-title-wrap .top a {
	    font-weight: bold;
	    background-color: #f75706;
	    color: #fff;
	    display: flex;
	    justify-content: center;
	    align-items: center;
	    height: 97px;
	    width: 167px;
	    border-radius: 14px;
	    border: none;
	    text-decoration: none;
	}
	.config-title-wrap .link-excel {
		margin-top: 10px;
	    font-weight: 600;
	    background-color: #e2e8f0;
	    color: rgba(0, 0, 0, 0.8);
	    display: flex;
	    justify-content: center;
	    align-items: center;
	    gap: 8px;
	    height: 46px;
	    border-radius: 10px;
	    min-width: 337px;
	    width: 100%;
	}
	.event-common-click-dialog{
		cursor:pointer;
	}

	/* 订单自动注册 - section-header */
	.section-header {
	    position: relative;
	    border-bottom: 1px solid #e0e0e0;
	    margin-bottom: 20px;
	}
	.section-header h1 {
	    font-size: 22px;
	    font-weight: bold;
	    letter-spacing: -0.01em;
	    margin-top: 0px;
		margin-bottom: 40px;
	    text-align: left;
	}
	.section-header h1 span {
	    color: #ff5700;
	}
	.section-header p {
	    font-size: 14px;
	    line-height: 20px;
	    letter-spacing: -0.01em;
	    margin-bottom: 27px;
	}
	.section-header a {
	    display: inline-flex;
	    align-items: center;
	    justify-content: center;
	    height: 49px;
	    width: 190px;
	    gap: 6px;
	    background: #fff;
	    font-size: 15px;
	    letter-spacing: -0.01em;
	    color: #333;
	    border: 1px solid #808080;
	    text-decoration: none;
	    position: absolute;
	    top: 2px;
	    right: 0;
	    border-radius: 44px;
	}

</style>